import { useParams, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { petShowOptions } from '$api-client/@tanstack/react-query.gen'
import { Card, LinkButton, NotFound, Text, Tooltip } from '$components'
import { EditIcon } from '$components'
import { PetRoutePaths } from '$features/pets/routes/protected'
import { AnimatedOutlet } from '$components'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'
import { usePageTitle } from '$components'
import { PetsFilterParam } from '$features/pets/enums/filter-params'
import { Router } from '$utils/router'

export function NotesTab() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const { hasSubscriptionExpired } = useTenant()

  const { data, isLoading: isPetLoading } = useQuery({
    ...petShowOptions({
      path: {
        pet: Number(id),
      },
      query: {
        include_deleted: true,
        [PetsFilterParam.IncludeUnapproved]: searchParams.get(PetsFilterParam.IncludeUnapproved) === '1',
      },
    }),
  })

  const pet = data?.data

  usePageTitle(pet ? `${pet.name} - Notes` : 'Pet Notes')

  if (isPetLoading) {
    return 'Loading...'
  }

  if (!pet) { return <NotFound /> }

  return (
    <div className="flex flex-col gap-stack-section">
      <Card
        rounding="xl"
        padding="none"
      >
        <Card.Header
          padding="sm"
          className="flex justify-between items-center"
        >
          <Text type="h4">
            Notes
          </Text>

          {pet.approved_at && (
            <Tooltip
              content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
              disabled={!hasSubscriptionExpired}
            >
              <LinkButton
                variant="secondary"
                size="sm"
                to={Router.buildRoute(
                  PetRoutePaths.PetsNotesEdit,
                )}
                icon={EditIcon}
                disabled={hasSubscriptionExpired}
              >
                Edit
              </LinkButton>
            </Tooltip>
          )}
        </Card.Header>

        <Card.Content
          padding="sm"
          className="flex flex-col gap-stack-roomy"
        >
          <div>
            <Card.Label>Grooming Preferences</Card.Label>
            <Text type="s">
              {pet.grooming_preferences ?? 'No grooming preferences'}
            </Text>
          </div>

          <div>
            <Card.Label>Internal Notes</Card.Label>
            <Text type="s">
              {pet.internal_notes ?? 'No internal notes'}
            </Text>
          </div>
        </Card.Content>
      </Card>

      <AnimatedOutlet />
    </div>
  )
}
